import { Injectable } from "@angular/core";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root",
})
export class LocalService {
  constructor(private storageService: StorageService) { }

  ngOnInit(): void { }

  // Set the json data to local
  setJsonValue(key: string, value: any) {
    this.storageService.secureStorage.setItem(key, value);
  }
  // Get the json value from local
  getJsonValue(key: string) {
    let data: any;
    try {
      data = this.storageService.secureStorage.getItem(key);
    } catch (error) {
      data = null;

    }

    return data;
  } // Clear the local

  clearToken(key) {
    if (this.storageService.secureStorage && this.storageService.secureStorage) {
      return this.storageService.secureStorage.removeItem(key);
    }
  }
}
